/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BillingParty } from '../models/BillingParty';
import type { BillingPartyResult } from '../models/BillingPartyResult';
import type { Error } from '../models/Error';
import type { UpdateBillingParty } from '../models/UpdateBillingParty';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BillingPartyService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @param id
     * @returns BillingParty OK
     * @returns Error Error
     * @throws ApiError
     */
    public getBillingPartyById(
        id: string,
    ): CancelablePromise<BillingParty | Error> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/billing/billing-parties/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns BillingParty OK
     * @returns Error Error
     * @throws ApiError
     */
    public updateBillingPartyById(
        id: string,
        requestBody: UpdateBillingParty,
    ): CancelablePromise<BillingParty | Error> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/billing/billing-parties/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param limit
     * @param offset
     * @returns BillingPartyResult OK
     * @returns Error Error
     * @throws ApiError
     */
    public getBillingParties(
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<BillingPartyResult | Error> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/billing/billing-parties',
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }

}
